import { atom } from "recoil";

export const LedgerState = atom({
  key: "Ledger_v1",
  default: {
    localBalance: 0,
  },
});
